export const ERROR_CODE = {
  INFO_UPDATE: 41202, // 信息已更新
  ORDER_STATUS_UPDATE: 41203, // 订单状态发生改变
};
export const REFRESH_TIME = 1500; // refresh间隔时间

// 取消页icon引入
import rider from '@/assets/images/order/cancel/rider.png'
import merchat from '@/assets/images/order/cancel/merchat.png'
import i18n from '@/i18n/locale'


const waitRider = merchat;
const waitMerchant = merchat;
const waitMerchantNoRider = merchat;
const mealPreparation = merchat;
const delivery = rider;
const takeMeal = rider;
const waitBusinessCancel = merchat;
const businessRefuse = merchat;

export const STATUS_MAP = {
  120: 'waitRider', // 待骑手接单
  140: 'waitMerchant', // 骑手已接单，待商家接单
  1400: 'waitforRider', // 骑手正前往商家为您下单
  100: 'waitMerchantNoRider', // 商家已接单
  200: 'mealPreparation', // 商家备餐中
  2001: 'waitBusinessCancel', // 已发起取消，等待商家确认
  2002: 'businessRefuse', // 商家拒绝取消申请
  400: 'delivery', // 配送中
  500: 'takeMeal' // 待取餐
}

export const TITLE_MAP = {
  waitRider: i18n.t('正在寻找骑手'),
  waitMerchant: i18n.t('等待商家接单'),
  waitforRider: i18n.t('FoodC_nonaffiliate_Courier_is_iunG', /*骑手正前往商家为您下单*/ ),
  waitMerchantNoRider: i18n.t('等待商家接单'),
  mealPreparation: i18n.t('商家正在备餐'),
  delivery: i18n.t('骑手正在配送中'),
  takeMeal: i18n.t('骑手已到达'),
  waitBusinessCancel: i18n.t('已发起取消，等待商家确认'),
  businessRefuse: i18n.t('商家拒绝取消申请')
}

export const ICON_MAP = {
  waitRider,
  waitMerchant,
  waitMerchantNoRider,
  mealPreparation,
  delivery,
  takeMeal,
  waitBusinessCancel,
  businessRefuse
}
